import axios from "axios";

export default class TestimoniosService {
  getTestimonios() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "testimonios");
  }

  getTestimoniosAdmin() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "testimonios/admin");
  }

  crearTestimonio(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "testimonios", data);
  }

  editarTestimonio(data) {
    return axios.put(process.env.VUE_APP_API_PUBLIC + "testimonios", data);
  }

  eliminarTestimonio(id) {
    return axios.delete(process.env.VUE_APP_API_PUBLIC + "testimonios", { data: { id } });
  }
}
